module.exports = "/lucky-balls/img/infobox/info_Box_006.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_006.png
// module id = 1071
// module chunks = 0